import React from 'react';
import { motion } from 'framer-motion';
const logos = ['Northbeam', 'Verano', 'Quantic', 'Loopwork', 'Halcyon', 'Meridian', 'Foundry', 'Cadence'];
const testimonials = [{
  quote: 'We killed six dashboards and a weekly spreadsheet ritual. oursignals is the first time marketing and sales are literally looking at the same number.',
  name: 'Priya Nadeau',
  title: 'VP RevOps, Meridian'
}, {
  quote: 'Intent alerts hit our reps in Slack before the lead even fills out a form. Our response time went from hours to minutes.',
  name: 'Marcus Webb',
  title: 'Head of Sales, Loopwork'
}, {
  quote: 'I can finally tie ad spend to closed revenue without a data engineer. Attribution that the CFO actually believes.',
  name: 'Elena Cruz',
  title: 'Director of Growth, Quantic'
}];
export function SocialProof() {
  return <section className="py-20 md:py-28" data-id="element-191">
      <div className="mx-auto max-w-[1200px] px-5 md:px-8" data-id="element-192">
        <p className="text-center text-xs font-semibold uppercase tracking-widest text-ink/40" data-id="element-193">
          Trusted by modern revenue teams
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-10 gap-y-4" data-id="element-194">
          {logos.map(l => <span key={l} className="font-display text-xl font-medium text-ink/40" data-id="element-195">
              {l}
            </span>)}
        </div>

        <div className="mt-16 grid gap-6 lg:grid-cols-3" data-id="element-196">
          {testimonials.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex flex-col justify-between rounded-2xl border border-ink/15 bg-white p-7" data-id="element-197">
              <blockquote className="font-display text-lg leading-snug text-ink" data-id="element-198">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 border-t border-ink/10 pt-4" data-id="element-199">
                <div className="font-semibold" data-id="element-200">{t.name}</div>
                <div className="text-sm text-ink/50" data-id="element-201">{t.title}</div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}